import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'app-snackbar',
    imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
    template: `
    <span matSnackBarLabel style="flex: 1 1 auto;">{{data.message}}</span>
      <span matSnackBarActions>
        @if(data.event === 'redirect'){
          <button mat-button matSnackBarAction (click)="redirect()" >{{data.actionName}}</button>
        }
        @if(data.event === 'refresh'){
          <button mat-button matSnackBarAction (click)="refresh()" >{{data.actionName}}</button>
        }
        @if(data.event !== 'refresh'){
          <button mat-button matSnackBarAction (click)="close()" class="snackbar-error-button">Close</button>
        }
    </span>
  `,
    styles: `
    :host {
      display: flex;
    }
    .snackbar-error-button{
      color: red !important;
    }
  `
})
export class SnackbarComponent {

  message = signal<string>('');

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackRef: MatSnackBarRef<SnackbarComponent>,
    private router:Router
  ) { }

  close(){
    this.snackRef.dismiss();
  }

  redirect(){
    this.router.navigate([this.data.url]);
    this.snackRef.dismiss();
  }

  refresh(){
    window.location.reload();
  }


}
